import App from "../../../vendor_core/core/src/App";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import { Tween } from "../../../vendor_core/core/src/Tween";
import ConsoleUtil from "../../../vendor_core/core/src/utils/ConsoleUtil";
import GameLoader from "../../../vendor_core/core/src/utils/GameLoader";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorPreloadState from "../../../vendor_core/src/states/VendorPreloadState";
import GameSoundVars from "../enums/GameSoundVars";
import LocalData from "../../../vendor_core/core/src/utils/LocalData";
import LocalStorageVars from "../../../vendor_core/core/src/const/LocalStorageVars";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import { Container, Graphics } from "pixi.js";
import LogoHelper from "../view/logo/LogoHelper";
import CoinModel from '../../model/CoinModel';
import { getScatterBoostCost } from '../ui/commands/TRWGameCommands';
import ClockController from '../../../vendor_core/core/src/controllers/ClockController';
import ControllerManager from '../../../vendor_core/core/src/utils/ControllerManager';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import SpineAnimation from "../../../vendor_core/core/src/views/SpineAnimation";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";

export default class TRWPreloaderState extends VendorPreloadState {
	private activeTweens: Tween[] = [];

    protected setupReels(): void {

        const reelGroup = InstanceFactory.getClass("ReelGroup", true) as ReelGroup;

        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .addSubView(reelGroup, "ReelGroup", "reels");

        reelGroup.create(
            ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene(),
            null,
            {
                winLineLayer: "Paylines",
                celеbrationLayer: "PaylineCelebration",
                winSymbolsLayer: "ReelsWin",
            }
        );

        const clientMatrix = [
            [1, 1, 9, 7, 7],
            [6, 11, 2, 10, 5],
            [3, 9, 5, 5, 4],
            [3, 5, 1, 1, 11],
            [6, 10, 3, 7, 7],
            [6, 3, 3, 8, 7]
        ];

        const overlay = [
            {
                id: 4,
                text: "x10"
            },
            {
                id: 3,
                text: "5.0"
            },
        ]

        SpinModel.reelFinalSymbols = new Map();
        SpinModel.reelFinalSymbols.set(0, clientMatrix);

        reelGroup.reels.forEach((reel, ri) => {
            reel.symbols.forEach((symbol, si) => {
                // console.log(ri);
                const id = clientMatrix[ri][si];

                symbol.setId(id);
                if (id === 10) {
                    const overlayData = overlay.pop();
                    symbol.showTextOverlay(overlayData.id, overlayData.text)
                }
                symbol.playAnimation();
            });
        });

        reelGroup.sortSymbols();
    }

    startGame(): void {
        // BackgroundHelpers.backgroundOpen()
        //     .then(() => {
        //         BackgroundHelpers.backgroundLoop();
        //     });
        super.startGame();
		UIController.removeTurboListener();
        LogoHelper.init();
        this.initReelFrameAnim();
        VendorModel.allowSwipeSpin = false;
        ReelGroup.instance.disableSwipeSpin();
        CoinModel.changeState();
        const betBarScreen = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        const btnValue = betBarScreen.sceneMoneyFields.get("dc_bet_amount");

        const cost = getScatterBoostCost();
        
        const bgScene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
        const anim = bgScene?.spineAnimations?.get("animation");
        anim.play("mg_loop");

        // const chestScene = ViewManager.getLayer("ChestBar").getCurrentScene();
        // const animChest = chestScene?.spineAnimations?.get("chest");
        // if (Layout.isLandscape()) animChest.scale.set(0.6);

        // dirty hack for extending the container for Coin Fly spine anim (N.B. containerSize doesn't work here)
        const moveScene = ViewManager.getLayer("Move").getCurrentScene();
        const offsetY: number = 50 * Layout.globalScale;
        for (let i = 1; i <= 4; i++) {
            const animCollect = moveScene.spineAnimations.get(`collect_${i}`);
            const animGraphics = animCollect.parent.children[1] as Graphics;
            animGraphics.height += offsetY;
            animGraphics.y -= offsetY;
        }

        btnValue.value = cost;
        this.setupCoinBar();
        
        (ReelGroup.instance.winSymbolsView.children[0] as Container).sortableChildren = true;
    }


    protected initSoundLoading(): void {

        SoundController.musicVolume = App.config.maxMusicVolume || 1;

        GameLoader.loadSoundAssets(GameLoader.config.sounds, () => {
            ConsoleUtil.log("Sound resources loaded");

            CommandManager.execute(Commands.AUDIO_VISIBLE_CHANGE_EVENTS);
            SoundController.setSpecificMusicVolume(GameSoundVars.MUSIC_MAIN, 0);
            SoundController.loadSounds(GameLoader.config.sounds);
            SoundController.playMusic(GameSoundVars.MUSIC_MAIN);

            const storeMusicEnableValue = LocalData.getValue(LocalStorageVars.MUSIC_ENABLED);

            if(storeMusicEnableValue != null && storeMusicEnableValue != "true") {
                SoundController.toggleSound();
            }

        });

    }
    
	protected buildViews(): void {
		super.buildViews();
		this.setUpPreloadAnim();
	}

	protected onBtnClick = () => {
		const scene: SceneView = ViewManager.getLayer(DefaultLayers.Preloader).getCurrentScene();
		const anim: SpineAnimation = scene.spineAnimations.get("logo");
		this.setVisibleOnStartScene(scene, false);

		anim.playAsync("end").then(() => {
			ViewManager.getLayer(DefaultLayers.Preloader).clear();
			UIController.addTurboListener();
			SoundController.musicVolume = App.config.maxMusicVolume || 1;
			this.startGame();
		})
		anim.visible = true;
	}

    public preloadComplete() {
        
		ControllerManager.addController(
			"clockController",
			new ClockController()
		);

        super.preloadComplete();
    }

    public initReelFrameAnim(): void {
        const scene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const anim = scene.spineAnimations.get("frame_anticipation");
        anim.play("loop_mg");
    }

    private setUpPreloadAnim(): void {
		const scene = ViewManager.getLayer(DefaultLayers.Preloader).getCurrentScene();
		this.setVisibleOnStartScene(scene, false);
		this.playPreloadAnim(scene);
	}

    private playPreloadAnim(scene: SceneView): void {
		let isChines: boolean = (GameModel.lang == "zh-cn" || GameModel.lang == "zh-tw");
		const anim: SpineAnimation = scene.spineAnimations.get("logo");
		anim.skeleton.setSkinByName(isChines ? "chinese" : "english")
		anim.visible = true;
		anim.playChainingAnim(GameModel.isMobile() ? "preloader_pt" : "preloader").then(() => {
			this.setVisibleOnStartScene(scene, true);
		});
	}
    
	private setVisibleOnStartScene = (scene: SceneView, visible: boolean) => {
		let minFontSize: number = 100000;
		scene.sceneSprites.forEach(s => {
			if (s.name !== "bg" && visible === false) {
				s.visible = visible
			}
		});
		scene.sceneTextFields.forEach(t => {
			if (t.bound.id !== "play") {
				minFontSize = Math.min(minFontSize, Number(t["_text"]["style"]["fontSize"]));
			}
			if (visible) {
				this.activeTweens.push(Tween.to(t, 1, { alpha: 1 }));
			} else {
				this.activeTweens.forEach(t => t.kill());
				t.alpha = 0;
			}
		});
		scene.sceneTextFields.forEach(t => {
			if (t.bound.id !== "play") {
				(t as TextField).fixFontSize = minFontSize;
				t.applyBound();
			}
		});
		scene.buttons.forEach(b => b.visible = visible);
	}

    private setupCoinBar(): void {
        let idx: number = 0;
        const coinScene: SceneView = ViewManager.getLayer("CoinBar")?.getCurrentScene();
        coinScene.spineAnimations.forEach((s) => {
            s.play("blank");
            CoinModel.setCoinCollectionState(idx, true);
            idx++;
        });
    }
}
